export default __webpack_public_path__ + "static/media/oahucity-full.c2a67edf.png";